// Soft pastel chip styling, shared across reports.
//
// Mirrors the Project Status / Client Party Type chip palette used elsewhere
// in the app (constants/projectStatuses.js: getStatusColor + getStatusTextColor).
// Maps the semantic tokens (success / warning / error / info / default) to
// pastel-background / darker-text pairs so badges read as lighter without
// losing their meaning.
//
// Lifted out of DirectManagerDiscrepancies/chipStyles.js when the Employment
// Change Log report (ADR-145) became the second consumer — the same
// extract-on-second-use rule ADR-092 applied to representative scope. That
// file now re-exports this one, so its importers are untouched.

const PALETTE = {
  success: { bg: '#E6F4EA', color: '#1E8E3E' },
  warning: { bg: '#FEF3C7', color: '#92400E' },
  error:   { bg: '#FEE2E2', color: '#991B1B' },
  info:    { bg: '#DBEAFE', color: '#1E40AF' },
  default: { bg: '#F3F4F6', color: '#6B7280' },
};

export const getChipSx = (token) => {
  const { bg, color } = PALETTE[token] || PALETTE.default;
  return {
    backgroundColor: bg,
    color,
    fontWeight: 500,
    border: 'none',
    '& .MuiChip-label': { color },
  };
};

export default PALETTE;
